module.exports = __webpack_public_path__ + "static/media/Welcome_to_Fifo_Central.14e57d36.mp4";